<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
      width="220"
    >
      <v-card height="64" color="primary" tile>
        <v-list-item two-line>
          <v-list-item-avatar>
            <!--  -->
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-subtitle>
              <!--  -->
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>

      <v-list dense>
        <v-list-item :to="{ name: 'Invitations' }">
          <v-list-item-action>
            <v-icon>mdi-account-group</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Invitados</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{ name: 'UserList' }">
          <v-list-item-action>
            <v-icon>mdi-security</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Usuarios</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group
          no-action
          prepend-icon="mdi-shield-lock-outline"
        >
          <template v-slot:activator>
            <v-list-item-title>Log de Accesos</v-list-item-title>
          </template>

          <v-list-item
            :to="{ name: 'AccessLogList' }"
          >
            <v-list-item-title>
              Visuarlizar Log Accesos
            </v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group
            no-action
            prepend-icon="mdi-chart-line"
          >
          <template v-slot:activator>
            <v-list-item-title>Reportes</v-list-item-title>
          </template>

            <v-list-item
              v-for="([title, link], i) in reportes"
              :key="i"
              :to="{ name: link }"
            >
              <v-list-item-title>
                {{ title }}
              </v-list-item-title>

            </v-list-item>
        </v-list-group>
      </v-list>

    </v-navigation-drawer>
    <v-app-bar
      app
      color="white"
      class="elevation-1"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title
        class="body-2"
      >
        Sistema de control de acceso a la propiedad
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-menu bottom offset-y>
        <template v-slot:activator="{ on }">
          <v-card class="text-right elevation-0"
            v-on="on"
          >
            <v-list
              dense
              class="py-1"
              >
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-list-item-title>{{ user.full_name }}</v-list-item-title>
                  <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-avatar>
                  <img src="/static/images/av1.png">
                </v-list-item-avatar>
              </v-list-item>
            </v-list>
          </v-card>
        </template>
        <v-list>
          <v-list-item
            link
            href="https://bitbucket.org/grupopuntacana/bocelli/wiki/Home"
            target="_blank"
          >
            <v-list-item-title>Ayuda</v-list-item-title>
          </v-list-item>
          <v-list-item
             @click="showModalResetPassword()"
          >
            <v-list-item-title>Cambiar mi contraseña</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item
            :to="{ name: 'Logout' }"
          >
            <v-list-item-title>Salir</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

    </v-app-bar>

    <user-reset-my-password
      v-model="showResetPassword"
      :userId="user.pk"
    ></user-reset-my-password>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import types from '@/types';
import UserResetMyPassword from '@/components/UserResetMyPassword';

export default {
  components: {
    UserResetMyPassword,
  },

  data() {
    return {
      drawer: true,
      reportes: [
        ['Por Rango de fecha', 'InvitationsReportDate'],
        ['Por Propiedad', 'InvitationsReportProperty'],
      ],
      contratistas: [
        ['Listado contratistas', 'ContratistaAccesoListado'],
      ],
      showResetPassword: false,
    };
  },

  computed: {
    ...mapState(
      `${types.USER}`, [
        'user',
      ],
    ),
  },

  methods: {
    showModalResetPassword() {
      this.showResetPassword = true;
    },
  },

};
</script>



// WEBPACK FOOTER //
// src/components/Navbar.vue